import styled from "styled-components";

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.dimensions.spacing['4']};
`;

export const ListName = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.dimensions.spacing['1']};
`;

export const Description = styled.div`
  white-space: pre-line;
`;

export const DynamicListSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.dimensions.spacing['1']};
`;

export const DynamicListHint = styled.div`
  color: ${({ theme }) => theme.colors['grey-500']};
  font-size: ${({ theme }) => theme.dimensions.spacing['2']};
  padding-left: ${({ theme }) => theme.dimensions.spacing['6']};
`;